import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  PageheaderBulkApply,
  PageheaderBulkApplyVariables
} from "./types/PageheaderBulkApply"
import {
  PageheaderBulkDelete,
  PageheaderBulkDeleteVariables
} from "./types/PageheaderBulkDelete";
import {
  PageheaderCreate,
  PageheaderCreateVariables
} from "./types/PageheaderCreate";
import {
  PageheaderDelete,
  PageheaderDeleteVariables
} from "./types/PageheaderDelete";
import {
  PageheaderUpdate,
  PageheaderUpdateVariables
} from "./types/PageheaderUpdate";


const pageheaderCreate = gql`
  mutation PageheaderCreate($input: PageHeaderInput!) {
    pageHeaderCreate(input: $input) {
      pageHeader {
        id
      }
      errors: pageErrors {
        field
        code
      }
    }
  }
`;

export const usePageheaderCreateMutation = makeMutation<
  PageheaderCreate,
  PageheaderCreateVariables
>(pageheaderCreate);


const pageheaderUpdate = gql`
  mutation PageheaderUpdate($id: ID!, $input: PageHeaderInput!) {
    pageHeaderUpdate(id: $id, input: $input) {
      errors: pageErrors {
        field
        code
      }
    }
  }
`;

export const usePageheaderUpdateMutation = makeMutation<
  PageheaderUpdate,
  PageheaderUpdateVariables
>(pageheaderUpdate);


const pageheaderDelete = gql`
  mutation PageheaderDelete($id: ID!) {
    pageHeaderDelete(id: $id) {
      errors: pageErrors {
        message
      }
    }
  }
`;

export const usePageheaderDeleteMutation = makeMutation<
  PageheaderDelete,
  PageheaderDeleteVariables
>(pageheaderDelete);


const pageheaderBulkDelete = gql`
  mutation PageheaderBulkDelete($ids: [ID!]!) {
    pageHeaderBulkDelete(ids: $ids) {
      errors: pageErrors {
        message
      }
    }
  }
`;

export const usePageheaderBulkDeleteMutation = makeMutation<
  PageheaderBulkDelete,
  PageheaderBulkDeleteVariables
>(pageheaderBulkDelete);


const pageheaderBulkApply = gql`
  mutation PageheaderBulkApply($ids: [ID!]!, $pageHeaderId: ID!) {
    pageHeaderBulkApply(ids: $ids, pageHeaderId: $pageHeaderId) {
      errors: pageErrors {
        code
        field
        message
      }
      count
    }
  }
`;

export const usePageheaderBulkApplyMutation = makeMutation<
  PageheaderBulkApply,
  PageheaderBulkApplyVariables
>(pageheaderBulkApply);
